export const NOT_APPLICABLE = 'NOT_APPLICABLE';
